// skipcq: JS-W1028
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';

import { UserContext } from '../context/UserContext';
import { getVerifiedUserDestination } from '../utils/verifiedUserDestination';

export default function BrewhousePortalLandingRedirect() {
  const user = useContext(UserContext);

  return <Navigate to={getVerifiedUserDestination(user)} replace />;
}
